import React from 'react'
import { useStyles } from './OverviewEmptyState.styles'
import { Typography } from '@mui/material'

export interface OverviewEmptyStateProps {
  imgUrl: string
  imageHeight: number
  imageWidth: number
  containerHeight: number
  description: string
  button?: React.ReactNode
}

export const OverviewEmptyState: React.FC<OverviewEmptyStateProps> = ({
  imgUrl,
  imageHeight,
  imageWidth,
  containerHeight,
  description,
  button,
}) => {
  const { classes } = useStyles({ imageHeight, imageWidth, containerHeight })
  return (
    <div
      className={classes.rootContainer}
      data-testid="overview-empty-state-container"
    >
      <img
        data-testid="empty-state-image"
        src={imgUrl}
        alt="overview-empty-state-image"
        className={classes.emptyStateImg}
      />
      <Typography
        className={classes.description}
        data-testid="empty-state-description"
      >
        {description}
      </Typography>
      {button && button}
    </div>
  )
}
